import { search } from "../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/faturamento/contratos/v1/revisoes`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export const getViewLists = async ({ empresa_cnpj, idEmpresa, idUsuario }) =>
  search(
    `${path}?empresa_cnpj=${empresa_cnpj}&idEmpresa=${idEmpresa}&idUsuario=${idUsuario}`,
    "GET",
    headers
  );

export const createClienteContrato = async ({
  body,
  empresa_cnpj,
  idEmpresa,
}) =>
  search(
    `${path}?empresa_cnpj=${empresa_cnpj}&idEmpresa=${idEmpresa}`,
    "POST",
    headers,
    body
  );

export const updateClienteContrato = async ({
  id,
  body,
  empresa_cnpj,
  idEmpresa,
}) =>
  search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}&idEmpresa=${idEmpresa}`,
    "PUT",
    headers,
    body
  );
